$(document).ready(function(){
	const browser=browserCheck();
	const os=osCheck();
	const device=deviceCheck();
	$("body").addClass(browser).addClass(os);


  // <a href="#***">の場合、スクロール処理を追加
  $('a[href*="#"]').on("click",function() {
		if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
  		var $target = jQuery(this.hash);
      $target = $target.length && $target || jQuery('[name="' + this.hash.slice(1) +'"]');
      if ($target.length) {
      	const targetOffset = $target.offset().top;
        $('html,body').animate({ scrollTop: targetOffset }, 800, 'easeOutExpo');//fast
        //$('html,body').animate({ scrollTop: targetOffset }, 1000, 'easeInOutQuart');//smooth
        /*$('html, body').animate({scrollTop: targetOffset/5,opacity: 0}, 300, function() {
					$('html, body').animate({opacity: 1,scrollTop: targetOffset}, 600);
				});//fade scroll*/
        return false;
      }
    }
  });
  
  //Menu
  $("#menu-btn").on("click",function(){
	  $("#menu").toggleClass("open");
  });
  
  const bodyId=$("body").attr("id");
	if($("#gnavi ."+bodyId).length){
		$("#gnavi ."+bodyId).addClass("active");
  }
	
  
  //お知らせのNEW表示
  if($(".date[data-date]").length){
	  $(".date[data-date]").each(function(){
		  const nowdate=new Date();
		  const infodate=new Date($(this).data("date"));
		  const termDay = Math.ceil((nowdate - infodate) / 86400000);
		  //console.log(termDay);
		  
		  if(termDay < 7){
			  $(this).parent().prepend('<span class="new">NEW!</span>');
		  }
	  })
  }
  
  
	//顔写真のサイズ計測
	$face = $('img.face');
	if($('img.face').length){
		var img = new Image();
		img.src =$face.attr("src");
		const h=img.height;
    const w=img.width;
    const r=h/w;
    console.log(r);
    if(r < 1){
	    $face.addClass("hmax");
    }else{
	    $face.addClass("wmax");
    }
	}
	
	//タブ
	if($(".tab-list").length){
		$(".tab1").addClass("active");  
		$(".tab-list li").on("click",function(){
	    $(".tab-list .active").removeClass("active");
      $(".tab-contents .active").removeClass("active");
			var i = $(".tab-list li").index(this)+1;
      id="tab"+i;
      $(this).addClass("active");
      $(".tab-contents ."+id).addClass("active");
    });
  }
	//カレンダー
	if($('.datepicker').length){
		$(".datepicker").datepicker({
			language: 'ja',
		  format: "yyyy/mm/dd",
			autoclose: true,
			keyboardNavigation: false,
			clearBtn:true,
			maxViewMode:2
		});
	}
	if($(".birthpicker").length){//生年月日
	  $('.birthpicker').datepicker({
		  language: 'ja',
		  format: "yyyy/mm/dd",
			autoclose: true,
			keyboardNavigation: false,
			clearBtn:true,
			maxViewMode:2,
			startView:2
	  });
  }
  
  //ACCNパートナーの情報切り替え
  if($("#partnerFlag1").length){
	  if($("#partnerFlag1 input").prop("checked")){
		  $(".tab-list .profile").removeClass("hide");
	  }else{
		  $(".tab-list .profile").addClass("hide");
	  }
	  $("#partnerFlag1").on("click",function(){
		  if($(".tab-list .profile.hide").length){
			  $('html,body').animate({ scrollTop: $("#wrapper").offset().top }, 800, 'easeOutExpo',function(){
				  $(".tab-list .profile").removeClass("hide");
				  $(".tab-list .profile .popup").addClass("show");
			  });
		  }
	  });
	  $("#partnerFlag2").on("click",function(){
		  $(".tab-list .profile").addClass("hide");
	  });
  }
  
  /*都道府県から支部の入力*/
	if($("#pref").length && $("#member-shibu").length){
		if($("#pref")!=""){
			pref2Shibu($("#pref").val());
		}
		AjaxZip3.onSuccess = function(){
			pref2Shibu($("#pref").val());
		}
		$("#pref").on("change",function(){
			pref2Shibu($("#pref").val());
		});
	}
	/*海外在住の場合の支部を東京支部*/
	if($("#overseas").length && $("#member-shibu").length){
		if($("#overseas input").prop("checked")){
			pref2Shibu(13);
		}
		$("#overseas input").on("change",function(){
			if($("#overseas input").prop("checked")){
				pref2Shibu(13);
			}else{
				pref2Shibu($("#pref").val());
			}
		});
	}
	/*その他活動地域*/
	if($("#other_area").length){
		$('input',this).on("change",function(){
			if($('#other_area input:checked').length > 6){
				alert("その他の活動地はこれ以上選択できません");
				$(this).prop("checked",false);
			}
		});
	}
	
	//再検索
	if($(".research-link").length){
		$(".research-link").on("click",function(){
			if($(this).parents(".research.show").length){
				$(this).text("条件を変更する");
				$(this).parents(".research").removeClass("show");
			}else{
				$(this).text("検索条件を隠す");
				$(this).parents(".research").addClass("show");
			}
		});
	}
	//継続学習 詳細を見る
	if($(".detail-link").length){
		$(".detail-link").each(function(){
			if($(this).parents(".keizoku-box.show").length){
				$(this).text("詳細を隠す");
			}else{
				$(this).text("詳細を見る");
			}
		});
		$(".detail-link").on("click",function(){
			if($(this).parents(".keizoku-box.show").length){
				$(this).text("詳細を見る");
				$(this).parents(".keizoku-box").removeClass("show");
			}else{
				$(this).text("詳細を隠す");
				$(this).parents(".keizoku-box").addClass("show");
			}
		});
	}
	
	//scroll
  $(window).scroll(function () {
   	const body = window.document.body;
	 	const html = window.document.documentElement;
	 	const scrTop = body.scrollTop || html.scrollTop;
	 	const scrBottom = html.scrollHeight - html.clientHeight - scrTop;
	 	if(scrTop > 300){
			
		}
		if(scrBottom >= 0){
		
		}
  });
});
/*都道府県から支部の入力*/
/*"北海道支部":"北海道",
		"東北支部":"青森県/岩手県/宮城県/秋田県/山形県/福島県",
		"北関東支部":"茨城県/栃木県/群馬県/埼玉県/千葉県/新潟県",
		"東京支部":"/東京都/",
		"神奈川支部":"/神奈川県/",
		"中部支部":"愛知県/岐阜県/静岡県/三重県/長野県/石川県/富山県/福井県/山梨県",
		"関西支部":"滋賀県/京都府/大阪府/兵庫県/奈良県/和歌山県",
		"中国・四国支部":"鳥取県/島根県/岡山県/広島県/山口県/徳島県/香川県/愛媛県/高知県",
		"九州・沖縄支部":"福岡県/佐賀県/長崎県/熊本県/大分県/宮崎県/鹿児島県/沖縄県",
*/
function pref2Shibu(p){
	p2 = '/' + p + '/';
	const prefArray={
		"北海道支部":"/1/",
		"東北支部":"/2/3/4/5/6/7/",
		"北関東支部":"/8/9/10/11/12/15/",
		"東京支部":"/13/",
		"神奈川支部":"/14/",
		"中部支部":"/23/21/22/24/20/17/16/18/19/",
		"関西支部":"/25/26/27/28/29/30/",
		"中国・四国支部":"/31/32/33/34/35/36/37/38/39/",
		"九州・沖縄支部":"/40/41/42/43/44/45/46/47/",
	};
	for(key in prefArray){
		if(prefArray[key].indexOf(p2)!=-1){
			$("#member-shibu").val(key);
		}
	}
}

//画面サイズごとの処理
$(window).on('load resize', function(){
	const w = $(window).width();
	deviceFunc(w);
});

function deviceFunc(w){
	const bp = [599,960,1280];
	if (w <= bp[0]) {
		//sp
		$(".tel-number").each(function(){
			if(!$(this).parent(".tel-wrap").length){
				const no = $(this).data("tel");
				$(this).wrap('<a href="tel:' + no + '" class="tel-wrap"></a>');
			}
		});
		if($(".top-links + .top-accninfo").length){
			$(".top-accninfo").insertBefore('.top-shibu');
		}
  } else if(w <= bp[1]){
		//tb
		$(".tel-wrap .tel-number").each(function(){
			$(this).unwrap();
		});
		if($(".top-accninfo + .top-shibu").length){
			$(".top-accninfo").insertAfter('.top-links');
		}
  } else if(w <= bp[2]){
		//small pc
		
  } else{
  
  }
}

/*ブラウザ判別*/
function browserCheck(){
	const ua = window.navigator.userAgent.toLowerCase();
	const av = window.navigator.appVersion.toLowerCase();
	if(ua.indexOf('edge') != -1){
		return 'edge';
	}else if (ua.indexOf('opera') != -1) {
  	return 'opera';
	}else if (ua.indexOf("msie") != -1 || ua.indexOf("trident") != -1) {
		$("html").addClass('ie');
  	if (av.indexOf("msie 6.") != -1) {
    	return 'ie6';
  	} else if (av.indexOf("msie 7.") != -1) {
    	return 'ie7';
  	} else if (av.indexOf("msie 8.") != -1) {
    	return 'ie8';
  	} else if (av.indexOf("msie 9.") != -1) {
    	return 'ie9';
  	}else if (av.indexOf("msie 10.") != -1) {
    	return 'ie10';
  	}else if (av.indexOf("rv:11.") != -1) {
    	return 'ie11';
  	}
	} else if (ua.indexOf('chrome') != -1) {
  	return 'chrome';
	} else if (ua.indexOf('safari') != -1) {
  	return 'safari';
	} else if (ua.indexOf('gecko') != -1) {
  	return 'firefox';
	} else {
  	return false;
	}
}

/*OS判別*/
function osCheck(){
	const ua = window.navigator.userAgent.toLowerCase();
	if (ua.indexOf('windows') != -1) {
		if(ua.indexOf('phone') != -1){
			return 'winphone';
		}else{
			return 'win';
		}
	}else if(ua.indexOf('iphone') != -1) {
		return 'iphone';
	}else if(ua.indexOf('ipad') != -1) {
		return 'ipad';
	}else if(ua.indexOf('mac') != -1) {
		return 'mac';
	}else if(ua.indexOf('android') != -1) {
		if(ua.indexOf('mobile') != -1){
			if(ua.indexOf('A1_07') != -1){
				return 'tablet';
			}else if(ua.indexOf('SC-01C') != -1){
				return 'tablet';
			}else{	return 'android';}
		}else{
			return 'tablet';
		}
	}else{
		return false;
	}
}

/*デバイス判別*/
function deviceCheck(){
	const ua = window.navigator.userAgent.toLowerCase();
	if((ua.indexOf("windows") != -1 && ua.indexOf("touch") != -1 && ua.indexOf("tablet pc") == -1) 
      || ua.indexOf("ipad") != -1
      || (ua.indexOf("android") != -1 && ua.indexOf("mobile") == -1)
      || (ua.indexOf("firefox") != -1 && ua.indexOf("tablet") != -1)
      || ua.indexOf("kindle") != -1
      || ua.indexOf("silk") != -1
      || ua.indexOf("playbook") != -1){
      return 'tab';
    }else if((ua.indexOf("windows") != -1 && ua.indexOf("phone") != -1)
      || ua.indexOf("iphone") != -1
      || ua.indexOf("ipod") != -1
      || (ua.indexOf("android") != -1 && ua.indexOf("mobile") != -1)
      || (ua.indexOf("firefox") != -1 && ua.indexOf("mobile") != -1)
      || ua.indexOf("blackberry") != -1){
	    return 'sp';
    }else{
      return 'pc';
    }
}